export default {
  name: 'env',
  namespaced: true,
  state: process.env.common
}
